var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showing)?_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"msg"},[_vm._v("Cargando datos ...")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }